import alerts from "src/locale/en/alerts";
import buttons from "src/locale/en/buttons";
import common from "src/locale/en/common";
import form from "src/locale/en/form";
import schemes from "src/locale/en/schemes";
import forms from "src/locale/en/forms";
import layout from "src/locale/en/layout";
import chat from "src/locale/en/modules/chat";
import elements from "src/locale/en/modules/elements";
import onboarding from "src/locale/en/modules/onboarding";
import payments from "src/locale/en/modules/payments";
import registrations from "src/locale/en/modules/registrations";
import reviews from "src/locale/en/modules/reviews";
import tasks from "src/locale/en/modules/tasks";
import middlewares from "src/locale/en/modules/middlewares";
import network from "src/locale/en/modules/network";
import offer from "src/locale/en/modules/offer";
import promotion from "src/locale/en/modules/promotion";
import resume from "src/locale/en/modules/resume";
import envelope from "src/locale/en/modules/envelope";
import subscription from "src/locale/en/modules/subscription";
import support from "src/locale/en/modules/support";
import auth from "src/locale/en/modules/auth";
import lists from "src/locale/en/lists";
import authView from "src/locale/en/views/auth";
import credit from "src/locale/en/views/credit";
import dashboard from "src/locale/en/views/dashboard";
import envelopeView from "src/locale/en/views/envelope";
import inbox from "src/locale/en/views/inbox";
import networkView from "src/locale/en/views/network";
import offerView from "src/locale/en/views/offer";
import paymentView from "src/locale/en/views/payment";
import profileView from "src/locale/en/views/profile";
import referralView from "src/locale/en/views/referral";
import resumeView from "src/locale/en/views/resume";
import reviewView from "src/locale/en/views/review";
import settingView from "src/locale/en/views/setting";
import signerView from "src/locale/en/views/signer";
import subscriptionView from "src/locale/en/views/subscription";
import talentView from "src/locale/en/views/talent";
import taskView from "src/locale/en/views/task";
import shareNetworkView from "src/locale/en/views/shareNetwork";
import shareNetwork from "src/locale/en/modules/shareNetwork";
import exampleTasks from "src/locale/en/hooks/exampleTasks";
import providers from "src/locale/en/modules/providers";

const nl = {
	common,
	form,
	schemes,
	layout,
	buttons,
	alerts,
	forms,
	payments,
	onboarding,
	registrations,
	reviews,
	tasks,
	elements,
	chat,
	lists,
	middlewares,
	network,
	offer,
	promotion,
	resume,
	envelope,
	subscription,
	support,
	auth,
	providers,
	"share-network": shareNetwork,
	"auth-view": authView,
	"credit-view": credit,
	"dashboard-view": dashboard,
	"envelope-view": envelopeView,
	"inbox-view": inbox,
	"network-view": networkView,
	"offer-view": offerView,
	"payment-view": paymentView,
	"profile-view": profileView,
	"referral-view": referralView,
	"resume-view": resumeView,
	"review-view": reviewView,
	"setting-view": settingView,
	"signer-view": signerView,
	"subscription-view": subscriptionView,
	"talent-view": talentView,
	"task-view": taskView,
	"share-network-view": shareNetworkView,
	"example-tasks-hook": exampleTasks,
};

export default nl;
